import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css'
import App from './App.vue'
import router from './router'
import store from './store'
import global from './utils/global'
import SIdentify from './utils/identify'
import './assets/css/comment.less'


// import VueSocketIO from 'vue-socket.io'
// import ClientSocketIO from 'socket.io-client'
//
// Vue.use(new VueSocketIO({
//     debug: true,
//    // // connection: 'http://localhost:3514', // 本地
//    // connection: 'http://106.55.191.70:3513', // 服务器
//    //  // connection: ClientSocketIO.connect('http://106.55.191.70:3513/'), //  会链接多次
//    //  transports: ['websocket'],
//    //  options: { path: ""}
// }))

Vue.use(ElementUI);
Vue.config.productionTip = false

/*全局变量，方法*/
Object.keys(global).forEach(key => {
    Vue.prototype[key] = global[key];
});


new Vue({
    router,
    store,
    // Sortable,
    render: h => h(App)
}).$mount('#app')
